/** Puvio Identity service — wraps the Genesis identity API. */
import apiClient from "../api_client/apiClient";

export const puvioService = {
  /** Existing auth backend (Google + Guest) routed through Puvio. */
  signInWithGoogle: () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  },
  signInAsGuest: () => apiClient.post("/auth/guest"),
  signOut: () => apiClient.post("/auth/logout"),

  /** Unified Puvio user view (with ecosystem identity). */
  me: () => apiClient.get("/genesis/identity/me"),
  updateProfileMetadata: (patch) => apiClient.put("/genesis/identity/profile-metadata", patch),

  listProviders: () => apiClient.get("/genesis/identity/providers"),
  linkProvider: (provider, proof) => apiClient.post("/genesis/identity/providers/link", { provider, proof }),
  unlinkProvider: (provider) => apiClient.delete(`/genesis/identity/providers/${provider}`),

  listDevices: () => apiClient.get("/genesis/identity/devices"),
  revokeDevice: (deviceId) => apiClient.delete(`/genesis/identity/devices/${deviceId}`),

  startRecovery: (method, contact) => apiClient.post("/genesis/identity/recovery", { method, contact }),
  pollRecovery: (requestId) => apiClient.get(`/genesis/identity/recovery/${requestId}`),

  setVerificationLevel: (level) => apiClient.post("/genesis/identity/verification", { level }),
};
